import React from 'react';
 
const purple = '#6941E6';
 
const PrivacyPolicy = () => (
  <div style={{ background: 'linear-gradient(135deg, #18171a 0%, #6941E6 100%)', color: '#fff', minHeight: '100vh', padding: '80px 0', fontFamily: 'inherit' }}>
    <div style={{ maxWidth: 800,margin: '40px auto', padding: '20px 24px', borderRadius: 18, background: '#232323', boxShadow: '0 4px 32px rgba(0,0,0,0.18)' }}>
      <h1 style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 40, color: purple }}>Privacy Policy</h1>
      <p style={{ fontSize: '1.1rem', marginBottom: 32 }}>
        Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Information We Collect</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        We may collect personal information such as your name, email address, and contact details when you interact with our site or contact us.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>How We Use Your Information</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        We use your information to provide, operate, and maintain our website, improve user experience, and communicate with you.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Sharing Your Information</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        We do not sell or rent your personal information to third parties. We may share information with service providers who assist us in operating our website.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Your Choices</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        You may opt out of certain communications or request deletion of your data by contacting us at <a href="mailto:info@vcnrworld.com" style={{ color: purple, textDecoration: 'underline' }}>info@vcnrworld.com</a>.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Contact Us</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 0 }}>
        If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@vcnrworld.com" style={{ color: purple, textDecoration: 'underline' }}>info@vcnrworld.com</a>.
      </p>
    </div>
  </div>
);
 
export default PrivacyPolicy;